var _defs, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCypress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m128 3c69.090909 0 125 55.9090909 125 125 0 69.090909-55.909091 125-125 125-69.0909091 0-125-55.909091-125-125 0-69.0909091 55.9090909-125 125-125z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    height: "104.8%",
    width: "104.8%",
    x: "-2.4%",
    y: "-2.4%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128 0c70.749091 0 128 57.2509091 128 128 0 70.749091-57.250909 128-128 128-70.7490909 0-128-57.250909-128-128 0-70.7490909 57.2509091-128 128-128z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m128 7.38596491c66.666667 0 120.614035 53.94736839 120.614035 120.61403509 0 66.666667-53.947368 120.614035-120.614035 120.614035-66.6666667 0-120.61403509-53.947368-120.61403509-120.614035 0-66.6666667 53.94736839-120.61403509 120.61403509-120.61403509z",
    fill: "#495057",
    mask: "url(#c)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m192.035088 181.070175c-4.385965 13.596492-10.964913 23.684211-20.175439 31.140351-9.210526 7.456141-21.491228 11.403509-36.842105 12.719299l-3.070176-20.175439c10.08772-1.31579 17.54386-3.508772 22.368421-7.017544 1.754386-1.315789 5.263158-5.263158 5.263158-5.263158l-36.403508-116.6666665h30.263157l21.052632 87.2807015 22.368421-87.2807015h29.385965zm-105.7017547-109.2105259c7.0175439 0 13.5964913.877193 18.8596487 3.0701755 5.701755 2.1929824 10.964913 5.2631579 16.228071 9.6491228l-12.280702 16.6666666c-3.508772-2.6315789-7.017544-4.3859649-10.0877194-5.7017544-3.0701755-1.3157894-7.0175439-1.7543859-10.5263158-1.7543859-14.9122807 0-22.3684211 11.4035083-22.3684211 34.6491223 0 11.842106 1.754386 20.175439 5.7017544 25 3.9473684 5.263158 9.2105263 7.456141 16.6666667 7.456141 3.5087719 0 7.0175438-.438597 10.0877193-1.754386 3.0701759-1.31579 6.5789469-3.070176 10.9649119-5.701755l12.280702 17.54386c-10.087719 8.333333-21.491228 12.280702-34.6491227 12.280702-10.5263158 0-19.2982456-2.192983-27.1929824-6.578947-7.4561404-4.385965-13.5964913-10.964913-17.5438597-19.298246s-6.1403509-17.982456-6.1403509-29.385965c0-10.964912 2.1929825-21.052632 6.1403509-29.3859649 3.9473684-8.7719298 10.0877193-15.3508772 17.5438597-20.1754386 7.4561403-3.9473684 16.2280701-6.5789474 26.3157894-6.5789474z",
    fill: "#fff",
    mask: "url(#c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCypress);
export default __webpack_public_path__ + "static/media/cypress.950647791f9ebc0df4792f03b4bd192d.svg";
export { ForwardRef as ReactComponent };